/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  UnitType,
  InverterAnalyticalInDB,
  InverterIGBTData,
  InverterMOSFETData,
  InverterSimpleData,
  PWMFrequencyDefinition,
  InverterLossMapID,
} from 'src/api';
import { ConceptInputComponent } from '../../../forms/input/concept-input.component';
import { AWCListItem } from '@ansys-internal/awc-angular/list';
import { FlexLayout } from '@ansys-internal/awc-angular/core';
import { State } from '@ansys-internal/awf-angular/store';
import { AWCTreeItem } from '@ansys-internal/awc-angular/tree';
import { SetComponentDataAction } from '../../../../../actions/set-component-data/set-component-data.action';
import { ActionContributionsService } from '@ansys-internal/awf-angular/contributions';
import { ConceptInputType } from '../../../../../shared/enums';
import { CommonModule } from '@angular/common';
import { InputType } from '@ansys-internal/awc-angular/forms';
import { SelectSize} from '@ansys-internal/awc-angular/select';
import {InverterLossesType} from "../../../../../shared/enums/inverter-losses-type";
import {FormSelectComponent} from "@ansys-internal/awc-angular/form-select";
import {AWCFormElementSize} from "@ansys-internal/awc-angular/form";
export type SetPart = [value: string, type: string, id: string, index?: number];
type InverterData =
  | InverterSimpleData
  | InverterIGBTData
  | InverterMOSFETData
  | InverterLossMapID;

@Component({
    selector: 'app-inverter-inputs',
    templateUrl: './inverter.component.html',
    styleUrls: ['../inputs.scss'],
    imports: [ConceptInputComponent, CommonModule, FormSelectComponent]
})
export class InverterComponent {
  @Input() part!: InverterAnalyticalInDB;
  // | InverterIGBTData
  // | InverterMOSFETData
  // | InverterSimpleData
  // | InverterLossMapID;
  @Input() update!: boolean;
  @Input() readonly!: boolean;
  @Output() setPart: EventEmitter<SetPart> = new EventEmitter<SetPart>();
  @Output() forceUpdate: EventEmitter<string> = new EventEmitter<string>();
  readonly PWMFrequencyDefinition = PWMFrequencyDefinition;
  protected UnitType = UnitType;
  protected InputTypes = InputType;
  protected simpleData!: InverterSimpleData;
  protected igbtData!: InverterIGBTData;
  protected mosfetData!: InverterMOSFETData;
  protected lossMapData!: InverterLossMapID;
  protected filteredItems: AWCTreeItem[] = [];
  protected pwmDefinitions: AWCListItem[] = [
    {
      text: 'Fixed',
      id: '1',
    },
    {
      text: 'Synchronous',
      id: '2',
    },
  ];
  protected selectedDefinition: string[] = ['1'];
  protected layout: FlexLayout = FlexLayout.COLUMN;

  constructor(
    protected state: State,
    private actionContributionsService: ActionContributionsService
  ) {}

  ngOnInit(): void {
    if ((this.part.inverter_data as any)?.inverter_type === 'simple') {
      this.simpleData = this.part.inverter_data as InverterSimpleData;
    } else {
      switch (this.part.component_type) {
        case 'InverterAnalytical':
          this.igbtData = this.part.inverter_data as InverterIGBTData;
          this.mosfetData = this.part.inverter_data as InverterMOSFETData;

          this.selectedDefinition = [
            this.igbtData.pwm_definition === PWMFrequencyDefinition._1
              ? '1'
              : '2',
          ];
          break;
        case 'InverterLossMapID':
          this.lossMapData = this.part as InverterLossMapID;
          break;
      }
    }
  }

  /**
   * Set Inverter data
   */
  protected setInverterData(
    value: string | number,
    type: string,
    id: string
  ): void {
    if (this.part.component_type === 'InverterLossMapID') {
      (this.part as InverterLossMapID)[type as keyof InverterLossMapID] =
        value as any;
    } else {
      (this.part.inverter_data as any)[type as keyof InverterData] =
        value as any;
    }
    this.forceUpdate.emit(id);
  }

  protected changeDefinition(value: string | undefined): void {
    this.igbtData.pwm_definition =
      value === '1' ? PWMFrequencyDefinition._1 : PWMFrequencyDefinition._2;
    this.mosfetData.pwm_definition =
      value === '1' ? PWMFrequencyDefinition._1 : PWMFrequencyDefinition._2;
    this.forceUpdate.emit('pwm_definition');
  }

  protected readonly SelectSize = SelectSize;
  protected readonly AWCFormElementSize = AWCFormElementSize;
}
